export const getHeroType = (heroType) => {
  const hero = {
    RECYCLE_SHOP: {
      title: 'ร้านรับซื้อขยะรีไซเคิล',
      icon: require('../assets/icons/icon_recycle_shop.svg')
    },
    SCOOTER: {
      title: 'รถรับซื้อขยะรีไซเคิล',
      icon: require('../assets/icons/icon_scooter.svg')
    },
    DROP_POINT: {
      title: 'จุดรับบริจาคขยะรีไซเคิล',
      icon: require('../assets/icons/icon_drop_point.svg')
    },
    POSTAL: {
      title: 'รับขยะรีไซเคิลทางพัสดุ',
      icon: require('../assets/icons/icon_postal.svg')
    },
    CIRCULAR_BIN: {
      title: 'Circular Bin',
      icon: require('../assets/icons/icon_circular_bin.svg')
    },
    USER: {
      title: 'User',
      icon: require('../assets/icons/icon_user.png')
    }
  }

  return hero[heroType]
}

export function toBuddhistYear(moment, format) {
  const christianYear = moment.format('YYYY')
  const buddhishYear = (parseInt(christianYear, 10) + 543).toString()
  return moment
    .format(
      format
        .replace('YYYY', buddhishYear)
        .replace('YY', buddhishYear.substring(2, 4))
    )
    .replace(christianYear, buddhishYear)
}
